// API service for procedure management
const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:3001/api';

class ProcedureService {
  static async getAllProcedures(token) {
    try {
      const response = await fetch(`${API_BASE_URL}/procedures`, {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      return data;
    } catch (error) {
      console.error('Error fetching all procedures:', error);
      throw error;
    }
  }

  static async getProcedures(token, limit = 50, lastKey = null) {
    try {
      let url = `${API_BASE_URL}/procedures?limit=${limit}`;
      if (lastKey) {
        url += `&lastKey=${encodeURIComponent(JSON.stringify(lastKey))}`;
      }

      const response = await fetch(url, {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      return {
        procedures: data.data,
        pagination: data.pagination
      };
    } catch (error) {
      console.error('Error fetching procedures:', error);
      throw error;
    }
  }

  static async getProcedureById(procedureId, token) {
    try {
      const response = await fetch(`${API_BASE_URL}/procedures/${procedureId}`, {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      return data.data;
    } catch (error) {
      console.error('Error fetching procedure:', error);
      throw error;
    }
  }

  static async createProcedure(procedureData, token) {
    try {
      const response = await fetch(`${API_BASE_URL}/procedures`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(procedureData),
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      return data.data;
    } catch (error) {
      console.error('Error creating procedure:', error);
      throw error;
    }
  }

  static async updateProcedure(procedureId, procedureData, token) {
    try {
      const response = await fetch(`${API_BASE_URL}/procedures/${procedureId}`, {
        method: 'PUT',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(procedureData),
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      return data.data;
    } catch (error) {
      console.error('Error updating procedure:', error);
      throw error;
    }
  }

  static async deleteProcedure(procedureId, token) {
    try {
      const response = await fetch(`${API_BASE_URL}/procedures/${procedureId}`, {
        method: 'DELETE',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      return data;
    } catch (error) {
      console.error('Error deleting procedure:', error);
      throw error;
    }
  }

  static async searchProcedures(query, token) {
    try {
      const response = await fetch(`${API_BASE_URL}/procedures/search?query=${encodeURIComponent(query)}`, {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      return data.data;
    } catch (error) {
      console.error('Error searching procedures:', error);
      throw error;
    }
  }

  static async getProcedureStats(token) {
    try {
      const response = await fetch(`${API_BASE_URL}/procedures/stats`, {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      return data.data;
    } catch (error) {
      console.error('Error fetching procedure stats:', error);
      throw error;
    }
  }
}

export default ProcedureService;
